import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { GreetingHero } from "./_components/greeting-hero";
import { JumpBackIn } from "./_components/jump-back-in";
import { ModuleGrid } from "./_components/module-grid";

export function HomeView() {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Wide}>
      <div className="space-y-6">
        <GreetingHero />
        <JumpBackIn />
        <ModuleGrid />
      </div>
    </CenteredLayout>
  );
}
